/* eslint-env es6 */
import moment from 'moment';

export const FLOW_LABELS = {
  DEPOSIT: 'Deposit',
  DABA_PRO_SUBSCRIPTION: 'Daba Pro subscription',
};

export const FLOW_REASONS = {
  DEPOSIT: [
    'METHOD_NOT_LISTED',
    'FEES_TOO_HIGH',
    'LIMIT_TOO_LOW',
    'PAYMENT_FAILING',
    'NEED_ACCOUNT_VERIFICATION',
    'OTHER',
  ],
  DABA_PRO_SUBSCRIPTION: [
    'PRICE',
    'UNSURE_WHICH_PLAN',
    'WANT_TO_TRY_FIRST',
    'PAYMENT_METHOD_NOT_SUPPORTED',
    'PAYMENT_FAILING',
    'OTHER',
  ],
};

export const FLOW_STEPS = {
  DEPOSIT: ['CURRENCY', 'METHOD', 'AMOUNT', 'PAYMENT'],
  DABA_PRO_SUBSCRIPTION: ['PLAN', 'PAYMENT'],
};

export const PLATFORMS = ['IOS', 'ANDROID', 'WEB'];

const forFlow = (byFlow, flow) =>
  flow ? byFlow[flow] || [] : [...new Set(Object.values(byFlow).flat())];

export const getReasons = flow => forFlow(FLOW_REASONS, flow);
export const getSteps = flow => forFlow(FLOW_STEPS, flow);

const listFilter = (key, values = []) => (values.length ? {[key]: values} : {});

export const buildCheckoutFilters = ({
  flow,
  reasons = [],
  steps = [],
  currencies,
  paymentMethods,
  platforms,
  subscriptionPlans = [],
  billingCycles = [],
  userId,
  dateFrom,
  dateTo,
}) => {
  // Preserve the selected calendar date, regardless of the admin's timezone.
  const from = dateFrom ? moment.utc(dateFrom.format('YYYY-MM-DD')) : null;
  const to = dateTo ? moment.utc(dateTo.format('YYYY-MM-DD')) : null;
  if (from && to) {
    if (from.isAfter(to))
      throw new Error('Start date must be on or before end date.');
    if (to.diff(from, 'days') + 1 > 366) {
      throw new Error('Choose a date range of at most 366 days.');
    }
  }
  const isPro = flow === 'DABA_PRO_SUBSCRIPTION';
  const trimmed = values => values.map(value => value.trim()).filter(Boolean);
  return {
    ...(flow && {flow}),
    ...listFilter(
      'reasons',
      reasons.filter(reason => getReasons(flow).includes(reason)),
    ),
    ...listFilter(
      'steps',
      steps.filter(step => getSteps(flow).includes(step)),
    ),
    ...listFilter('currencies', currencies),
    ...listFilter('paymentMethods', paymentMethods),
    ...listFilter('platforms', platforms),
    // Plans and billing cycles exist only on Daba Pro logs.
    ...(isPro && listFilter('subscriptionPlans', trimmed(subscriptionPlans))),
    ...(isPro && listFilter('billingCycles', trimmed(billingCycles))),
    ...(userId?.trim() && {userId: userId.trim()}),
    ...(from && {dateFrom: from.toISOString()}),
    ...(to && {dateTo: to.toISOString()}),
  };
};
